module.exports = __webpack_public_path__ + "static/media/room1purple.5fd08aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/bridging-the-gap/room1purple.png
// module id = 136
// module chunks = 0